import React, { useState,useEffect } from "react";
import EmployeeNavbar from "./EmployeeNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
function TechnicalSupportEmployee() {
    const ID = Cookies.get("log_id");
    const [empname,setEmpname] = useState("");
    const [empID,setEmpid] = useState("");
    const [email,setEmail] = useState("");
    const [contact,setContact] = useState("");
    const [problem,setProblem] = useState("");
    const [Description,setDescription] = useState("");
    function Fetch_Employee_Details() {
        axios.get(`${url.path}/fetch_profile_details/${ID}/`)
        .then((res) =>{
            if(res.data.status){
                var emp = res.data.profile;
                setEmpname(emp.Employee_Name);
                setEmail(emp.Email);
                setEmpid(emp.Employee_ID);
                setContact(emp.Contact_number);
            }
        }).catch((err) => {
            console.log("ERROR", err);
          }); 
    }
    useEffect(()=>{
        Fetch_Employee_Details();
    },[])
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
    });
    function handleSubmit(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('name',empname);
        formdata.append('empid',empID);
        formdata.append('email',email);
        formdata.append('contact',contact);
        formdata.append('problem',problem);
        formdata.append('description',Description);
        axios.post(`${url.path}/technical_support_request_emp/`,formdata)
        .then((res) =>{
            if(res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Request Submitted..'
                })
                setProblem('');
                setDescription('');
            }
        }).catch((err) => {
            console.log("ERROR", err);
          }); 
    }
    return(
        <>
        <EmployeeNavbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Technical Support</h1>
                </div>
                <br />
                <form onSubmit={handleSubmit}>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Employee Name</label>
                            <input type="text" value={empname} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Employee ID</label>
                            <input type="text" value={empID} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="text" value={email} readOnly />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Contact</label>
                            <input type="text" value={contact} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Problem</label>
                            <input type="text" value={problem} onChange={(e) =>setProblem(e.target.value)}  />
                        </div>
                        <div className="form-group">
                            <label>Description</label>
                            <input type="text" value={Description} onChange={(e) =>setDescription(e.target.value)} />
                        </div>
                    </div>
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">Submit</button>
                        </div>
                    </center>
                </form>
                
            </div>

        </div>
        </>
    );
}
export default TechnicalSupportEmployee;